import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import ListFromTable from 'components/common/ListFromTable'
import * as AppRouter from 'constants/appRouting'
import ColumnCollection from 'types/table/ColumnCollection'
import Column from 'types/table/Column'
import Sort from 'lib/psfs/Sort'
import ActionCollection from 'types/table/ActionCollection'
import Action from 'types/table/Action'
import UrlHelper from 'helpers/url'
import {
  fetchSiteGroupTable,
  deleteSiteGroupInfo,
  clearSiteGroupTable,
} from 'reducers/siteGroup/reducer'
import ActiveColumn from 'types/table/ActiveColumn'
import messages from './translate'

class SiteGroupList extends ListFromTable {
  constructor(props) {
    super(props)
    this.getTableData = props.fetchSiteGroupTable
    this.deleteEntity = props.deleteSiteGroupInfo
    this.clearReducerState = props.clearSiteGroupTable
    this.asyncData = true
    this.loadingData = true
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    this.loadingData = nextProps.loader

    if (nextProps.licenseeId !== this.props.licenseeId) {
      this.reloadTableData(AppRouter.SITE_GROUP_LIST)

      return false
    }

    return super.shouldComponentUpdate(nextProps, nextState, nextContext)
  }

  getTableProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.siteGroupList),
      showFilterBar: true,
      sorting: true,
      paging: true,
      searching: false,
      creating: true,
    }
  }

  getCreateButton() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.createSiteGroup),
      link: AppRouter.SITE_GROUP_CREATE,
    }
  }

  getConfirmDialogProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.deleteSiteGroup),
      message: formatMessage(messages.deleteSiteGroupMessage),
    }
  }

  getColumns() {
    const {
      intl: { formatMessage },
    } = this.props
    const columns = new ColumnCollection()
    columns.add(new Column('id', 'ID', { sorting: true }))
    columns.add(
      new Column('name', formatMessage(messages.name), {
        sorting: true,
        defaultSort: true,
        defaultSortOrder: Sort.ASC,
      }),
    )
    columns.add(
      new Column('sites', formatMessage(messages.sites), {
        render: rowData => rowData.sites.map(site => site.name).join(', '),
      }),
    )
    columns.add(
      new ActiveColumn('visibleInUi', formatMessage(messages.visibleInUi), {
        sorting: true,
      }),
    )

    return columns
  }

  getActions() {
    const {
      history,
      intl: { formatMessage },
    } = this.props
    const actions = new ActionCollection()

    actions.add(
      new Action('edit', formatMessage(messages.editSiteGroup), row => {
        history.push(
          UrlHelper.create(AppRouter.SITE_GROUP_EDIT, { id: row.id }),
        )
      }),
    )
    actions.add(
      new Action('delete', formatMessage(messages.deleteSiteGroup), row => {
        this.onOpenConfirmDialog({ entityId: row.id, psfs: this.psfs })
      }),
    )

    return actions
  }
}

export default connect(
  state => ({
    tableData: state.getIn(['siteGroup', 'tableData']),
    loader: state.getIn(['siteGroup', 'isLoadTable']),
    licenseeId: state.getIn(['profile', 'licenseeId']),
  }),
  {
    fetchSiteGroupTable,
    deleteSiteGroupInfo,
    clearSiteGroupTable,
  },
)(injectIntl(SiteGroupList))
